var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"area-chart-container"},[_c('vue-apex-charts',{staticClass:"response-chart",attrs:{"id":"monitoring-chart","height":"250","options":_vm.chartOptions,"type":"area","series":_vm.resTimeSeriesComputed}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }